module.exports = __webpack_public_path__ + "img/certif-2.4f81c380.png";